import React, { useContext } from 'react';
import { CheckCircle, Package, ShoppingBag } from 'lucide-react';
import PagoOnline from './PagoOnline';
import { TiendaApi } from './tiendaUtils';

export default function PedidoCreado({ pedido, onVerPedidos }) {
  const { invitado } = useContext(TiendaApi);
  const Icono = invitado ? ShoppingBag : Package;
  return (
    <section className="mx-auto max-w-xl space-y-5" data-testid="tienda-pedido-creado">
      <div className="rounded-2xl border border-emerald-500/30 bg-emerald-500/10 p-5 text-center">
        <CheckCircle className="mx-auto mb-2 h-10 w-10 text-emerald-400" />
        <h2 className="font-serif text-xl text-white" data-testid="pedido-numero">¡Pedido {pedido.numero} creado!</h2>
        <p className="mt-1 text-sm text-zinc-300">
          {pedido.total_a_pagar > 0 ? 'Solo falta el pago para empezar a confeccionar tu prenda.' : 'Tu compra quedó cubierta con tus Puntos JPM.'}
        </p>
        {invitado && (
          <p className="mt-2 text-xs text-zinc-400" data-testid="pedido-invitado-aviso">
            Guarda el número de tu pedido. Te escribiremos por WhatsApp para coordinar tus medidas y la entrega.
          </p>
        )}
      </div>
      {pedido.total_a_pagar > 0 && (
        <div className="rounded-2xl border border-[#27272A] bg-[#18181B] p-5">
          <PagoOnline ordenId={pedido.orden_id} valor={pedido.total_a_pagar} enlace={pedido.enlace_pago} instrucciones={pedido.instrucciones_pago} />
        </div>
      )}
      <button onClick={onVerPedidos} className="flex w-full items-center justify-center gap-2 rounded-xl border border-[#27272A] py-3 text-sm text-zinc-200 transition-colors hover:border-[#C9A962]/50" data-testid="tienda-ver-pedidos">
        <Icono className="h-4 w-4" />{invitado ? 'Seguir explorando la colección' : 'Ver en Mis Pedidos'}
      </button>
    </section>
  );
}
